import { useState, useEffect } from "react";

const canMatch = () => typeof window !== "undefined" && typeof window.matchMedia === "function";

/**
 * Track a CSS media query. Starts with the current match so the first render
 * already lays out for the viewport (no table-then-grid flash on phones).
 *
 * @param {string} query e.g. "(max-width: 767px)"
 * @returns {boolean}
 */
export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() => (canMatch() ? window.matchMedia(query).matches : false));

  useEffect(() => {
    if (!canMatch()) return undefined;
    const mql = window.matchMedia(query);
    const handleChange = (event) => setMatches(event.matches);
    setMatches(mql.matches);
    // Safari < 14 only has the deprecated addListener/removeListener pair.
    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", handleChange);
      return () => mql.removeEventListener("change", handleChange);
    }
    mql.addListener(handleChange);
    return () => mql.removeListener(handleChange);
  }, [query]);

  return matches;
};
